import { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';

interface UseResponsiveWidthProps {
  query: string;
  fixedWidth: number;
}

export const useResponsiveWidth = ({ query, fixedWidth }: UseResponsiveWidthProps) => {
  const isMatch = useMediaQuery({ query });
  const [width, setWidth] = useState<number>(isMatch ? window.innerWidth : fixedWidth);

  useEffect(() => {
    const handleResize = () => {
      if (isMatch) {
        setWidth(window.innerWidth);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMatch]);

  return width;
};
